// extracted by mini-css-extract-plugin
module.exports = {"dropdownIcon":"messageModal_dropdownIcon__1lnBW","dropdownFilesWidth":"messageModal_dropdownFilesWidth__2V2Qk"};